import React from "react";
import { Cpu, Leaf, Diamond, KeyRound } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const icons = [Cpu, Leaf, Diamond, KeyRound];

const WhyChooseUs = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="why-section" className="relative bg-[#0F0F0F] py-32 lg:py-44 overflow-hidden">
      {/* Decorative gold corners */}
      <div className="absolute top-10 left-10 w-20 h-px bg-[#B08D57]/40"></div>
      <div className="absolute top-10 left-10 w-px h-20 bg-[#B08D57]/40"></div>
      <div className="absolute bottom-10 right-10 w-20 h-px bg-[#B08D57]/40"></div>
      <div className="absolute bottom-10 right-10 w-px h-20 bg-[#B08D57]/40"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 relative">
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-7">
            <span className="w-12 h-px bg-[#B08D57]"></span>
            <span className="overline-bold text-[#B08D57]">{t.why.overline}</span>
            <span className="w-12 h-px bg-[#B08D57]"></span>
          </div>
          <h2 className="font-display-thin text-white text-4xl sm:text-5xl lg:text-[64px] tracking-tight leading-[1.08]">
            {t.why.title}
          </h2>
          <p className="mt-7 text-white/65 text-base leading-[1.8] max-w-xl mx-auto">{t.why.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border-t border-b border-white/15">
          {t.why.items.map((item, i) => {
            const Icon = icons[i] || Cpu;
            return (
              <div
                key={i}
                data-testid={`why-card-${i}`}
                className="group bg-[#0F0F0F] p-10 hover:bg-[#1a1a1a] transition-colors duration-500 min-h-[280px] flex flex-col"
              >
                <div className="w-14 h-14 flex items-center justify-center border border-[#B08D57]/40 mb-8 group-hover:border-[#B08D57] group-hover:bg-[#B08D57]/10 transition-all">
                  <Icon className="w-6 h-6 text-[#B08D57]" strokeWidth={1.2} />
                </div>
                <h3 className="font-display text-white text-xl leading-tight mb-4">{item.title}</h3>
                <div className="w-8 h-px bg-[#B08D57] mb-5"></div>
                <p className="text-white/65 text-sm leading-[1.7] font-light flex-1">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
